import { Button, CircularProgress } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'

/**
 * Refresh control for upload history tables (brand red icon + label).
 */
const UploadHistoryRefreshButton = ({ onClick, loading = false, disabled = false, size = 'small' }) => {
  return (
    <Button
      startIcon={
        loading ? (
          <CircularProgress size={16} sx={{ color: '#e90000' }} />
        ) : (
          <RefreshIcon />
        )
      }
      onClick={onClick}
      size={size}
      disabled={disabled || loading}
      sx={{
        color: '#e90000',
        '&:hover': { bgcolor: '#E8F5E9' },
      }}
    >
      Refresh
    </Button>
  )
}

export default UploadHistoryRefreshButton
